var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("login-layout", [
    _c(
      "form",
      {
        staticClass: "t-login__form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("div", { staticClass: "t-login__field" }, [
          _c(
            "label",
            { staticClass: "control-label", attrs: { for: "email" } },
            [_vm._v("Email:")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email",
              },
            ],
            staticClass: "form-control",
            attrs: { id: "email", type: "email", name: "email", autofocus: "" },
            domProps: { value: _vm.email },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.email = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.errorMessages.email
            ? _c("span", { staticClass: "help-block" }, [
                _vm._v(_vm._s(_vm.errorMessages.email)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.token
          ? _c("div", { staticClass: "t-login__field" }, [
              _c(
                "label",
                { staticClass: "control-label", attrs: { for: "password" } },
                [_vm._v("Password:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "password", type: "password", name: "password" },
                domProps: { value: _vm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.password = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.errorMessages.password
                ? _c("span", { staticClass: "help-block" }, [
                    _vm._v(_vm._s(_vm.errorMessages.password)),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.token
          ? _c("div", { staticClass: "t-login__field" }, [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  attrs: { for: "confirm-password" },
                },
                [_vm._v("Confirm Password:")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.passwordConfirmation,
                    expression: "passwordConfirmation",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  id: "confirm-password",
                  type: "password",
                  name: "password",
                },
                domProps: { value: _vm.passwordConfirmation },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.passwordConfirmation = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.errorMessages.passwordConfirmation
                ? _c("span", { staticClass: "help-block" }, [
                    _vm._v(_vm._s(_vm.errorMessages.passwordConfirmation)),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ladda-button",
          {
            ref: "search",
            staticClass: "btn btn-dark",
            attrs: { type: "submit", click: _vm.handleSubmit },
          },
          [_vm._v("\n      Reset\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }